import React, { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { getNextMonth } from "../../../Utils/Utils";
import { CurrencyDisplay, KgDisplay } from "../../../Utils/Inputs";

export default function SKIMTotalesRows(props) {
    const { monthIndex, isFirstTable, month, ctoPromedioDelInvenTotalKgSecos, ctoPromedioDelInvenTotalValorTotal } = props;

    const { setValue } = useFormContext();

    // Cto. Promedio del Inven. Total
    const ctoPromedioDelInvenTotalCostoKgSecos = useMemo(() => (ctoPromedioDelInvenTotalValorTotal / ctoPromedioDelInvenTotalKgSecos), [ctoPromedioDelInvenTotalValorTotal, ctoPromedioDelInvenTotalKgSecos]);

    // Salidas a producción
    const salidasProdKgSecos = useMemo(() => ctoPromedioDelInvenTotalKgSecos, [ctoPromedioDelInvenTotalKgSecos]);
    const salidasProdCostoKgSecos = useMemo(() => ctoPromedioDelInvenTotalCostoKgSecos, [ctoPromedioDelInvenTotalCostoKgSecos]);
    const salidasProdValorTotal = useMemo(() => salidasProdKgSecos * salidasProdCostoKgSecos, [salidasProdKgSecos, salidasProdCostoKgSecos]);

    // Inventario Final
    const invenFinalKgSecos = useMemo(() => ctoPromedioDelInvenTotalKgSecos - salidasProdKgSecos, [ctoPromedioDelInvenTotalKgSecos, salidasProdKgSecos]);
    const invenFinalCostoKgSecos = useMemo(() => ctoPromedioDelInvenTotalCostoKgSecos, [ctoPromedioDelInvenTotalCostoKgSecos]);
    const invenFinalValorTotal = useMemo(() => invenFinalKgSecos * invenFinalCostoKgSecos, [invenFinalKgSecos, invenFinalCostoKgSecos]);

    // Actualizar inventarios iniciales de meses posteriores
    useEffect(() => {
        const nextMonth = getNextMonth(monthIndex);
        if (nextMonth === 'enero') return;

        setValue(`ComparativoCostoMP.SKIMData.InventarioInicial.${nextMonth}.KgSecos`, invenFinalKgSecos);
        setValue(`ComparativoCostoMP.SKIMData.InventarioInicial.${nextMonth}.CostoKgSec`, ctoPromedioDelInvenTotalCostoKgSecos);
    }, [invenFinalKgSecos, ctoPromedioDelInvenTotalCostoKgSecos, month, setValue]);

    return (
        <React.Fragment>
            {/* Cto. Promedio del Inven. Total */}
            <tr className='celda-totales'>
                <td><KgDisplay value={ctoPromedioDelInvenTotalKgSecos} /></td>
                <td><CurrencyDisplay value={ctoPromedioDelInvenTotalCostoKgSecos} decimalScale={5} /></td>
                <td><CurrencyDisplay value={ctoPromedioDelInvenTotalValorTotal} /></td>
            </tr>
            {/* Salidas a producción */}
            <tr>
                <td><KgDisplay value={salidasProdKgSecos} /></td>
                <td><CurrencyDisplay value={salidasProdCostoKgSecos} decimalScale={5} /></td>
                <td><CurrencyDisplay value={salidasProdValorTotal} /></td>
            </tr>
            {/* Inventario Final */}
            <tr className='celda-totales'>
                <td><KgDisplay value={invenFinalKgSecos} /></td>
                <td><CurrencyDisplay value={invenFinalCostoKgSecos} decimalScale={5} /></td>
                <td><CurrencyDisplay value={invenFinalValorTotal} /></td>
            </tr>
        </React.Fragment>
    );
}
